import { DeltaJsonElement } from '@/components/common/DeltaJsonElement';
import * as _m from '@/models';
import { useEffect, useMemo, useRef, useState } from 'react';
import { ReactHlsPlayer } from '@/components/common/ReactHlsPlayer';
import { Link, useLocation } from 'react-router-dom';
import { useCustomEvent } from '@/hooks/gtm/useCustomEvent';
import { useMoviePlays } from '@/hooks/api/useMoviePlays';

type Props = {
  playable: boolean;
  channel_post: _m.ChannelPost;
  from_modal?: boolean;
};
export const Body = ({ playable, channel_post }: Props) => {
  const location = useLocation();
  return (
    <div className="body">
      {playable ? (
        <div className="content-wrapper movie no-play detail">
          <MoviePlayer channel_post={channel_post} />
        </div>
      ) : (
        <Link
          to={`/channels/${channel_post.channel_outline.cid}/channel_posts/${channel_post.id}`}
          className={'content-wrapper movie'}
          // state={{ backgroundLocation: location }}
        >
          <img src={channel_post.cover_image_url} className={'img'} alt={''} />
          <div className={'time'}>{channel_post.channel_post_movie.duration_label}</div>
        </Link>
      )}
    </div>
  );
};

const MoviePlayer = ({ channel_post, ...props }: { channel_post: _m.ChannelPost }) => {
  const location = useLocation();
  const [played, setPlayed] = useState(false);
  const hlsPlayerRef = useRef<HTMLVideoElement>(null);
  const { moviePlayEvent } = useCustomEvent();
  const { mutation } = useMoviePlays();

  const onPlayClicked = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    setPlayed(true);
  };

  useEffect(() => {
    if (played) {
      moviePlayEvent(location.pathname);
      mutation.mutate({ cid: channel_post.channel_outline.cid, id: channel_post.id });
    }
  }, [played]);

  const player = (
    <ReactHlsPlayer
      playerRef={hlsPlayerRef}
      src={channel_post.channel_post_movie.movie_url}
      controls={true}
      controlsList={'nodownload'}
      onContextMenu={(e) => e.preventDefault()}
      type={'movie'}
      hlsConfig={{
        xhrSetup: (xhr: any) => {
          xhr.withCredentials = true;
        },
      }}
      poster={channel_post.cover_image_url}
      onPlay={(e) => onPlayClicked(e)}
      {...props}
    />
  );

  return useMemo(() => player, []);
};
